import * as React from 'react';
const { useCallback } = React;
import Menu from '@seeneco-ui/core/components/menu';
import Divider from '@seeneco-ui/core/components/divider';
import Typography from '@seeneco-ui/core/components/typography';
import Box, { BoxProps } from '@seeneco-ui/core/components/box';
import Icon from '@seeneco-ui/core/components/icon';
import {
	getPropInSafe,
} from '@seeneco-ui/core/utils';

import {
	Trigger,
	TenantName,
} from './styled';


export type AppSessionProps = {
	appearance?: 'default' | 'only-shell';
	isFetching: boolean;
	sessionContext: ClientSessionContext;
	tenantAccount: TenantAccount;
	onLogout: () => void;
	onNavigateToTenantAccount?: () => void;
};

const AppSession: React.SFC<AppSessionProps> = (props) => {
	const {
		appearance,
		isFetching,
		sessionContext,
		tenantAccount,
		onLogout,
		onNavigateToTenantAccount,
	} = props;
	const isOnlyShell = appearance === 'only-shell';
	const tenantName = isFetching ? '...' : getPropInSafe(sessionContext, o => o.SessionTenant.Name, '');
	const formattedTenantName = tenantName.toLowerCase();
	const tenantID = getPropInSafe(sessionContext, o => o.SessionTenant.ID, '');
	const login = getPropInSafe(sessionContext, o => o.SessionUser.Login, '');
	const businesServiceName = getPropInSafe(tenantAccount, o => o.BusinessService.Name, 'Не установлен');
	const tariffName = getPropInSafe(tenantAccount, o => o.ActiveTariff.Name, 'Не установлен');

	const handleNavigateToTenantAccount = useCallback((handleClose: (e) => void) => (e: React.SyntheticEvent) => {
		handleClose(e);
		onNavigateToTenantAccount();
	}, [onLogout]);

	const handleLogout = useCallback((handleClose: (e) => void) => (e: React.SyntheticEvent) => {
		handleClose(e);
		onLogout();
	}, [onLogout]);

	const renderTrigger = () => {
		return (
			<Trigger>
				<Box fontSize={0} marginRight='14px' title={formattedTenantName}>
					<Icon type='account-circle' color='muted' />
				</Box>
				<TenantName
					fontWeight={500}
					title={tenantName}>
					{formattedTenantName}
				</TenantName>
				<Box>
					<Icon type='arrow-drop-down' color='black' />
				</Box>
			</Trigger>
		);
	};

	return (
		<Menu.Base
			trigger={renderTrigger()}
			PopperProps={{
				style: { zIndex: 1300, marginRight: 7 }
			}}>
			{
				({ handleClose }) => (
					<Menu.List>
						{
							!isOnlyShell && 
							<Menu.Item minWidth={200} onClick={handleNavigateToTenantAccount(handleClose)}>Личный кабинет</Menu.Item>
						}
						<Menu.Item onClick={handleLogout(handleClose)}>Выйти</Menu.Item>
						<Divider margin='small' />
						<Menu.Item readonly>
							<span>
								<Label>Номер личного кабинета</Label>
								<Typography.Text fontWeight={500}># {tenantID}</Typography.Text>
							</span>
						</Menu.Item>
						<Menu.Item readonly>
							<span>
								<Label>Наименование личного кабинета</Label>
								<Typography.Text>{tenantName}</Typography.Text>
							</span>
						</Menu.Item>
						<Menu.Item readonly>
							<span>
								<Label>Логин</Label>
								<Typography.Text>{login}</Typography.Text>
							</span>
						</Menu.Item>
						<Menu.Item readonly>
							<span>
								<Label>Бизнес-сервис</Label>
								<Typography.Text>{businesServiceName}</Typography.Text>
							</span>
						</Menu.Item>
						<Menu.Item readonly>
							<span>
								<Label>Тариф</Label>
								<Typography.Text>{tariffName}</Typography.Text>
							</span>
						</Menu.Item>
					</Menu.List>
				)
			}
		</Menu.Base>
	);
}

AppSession.displayName = 'AppSession';
AppSession.defaultProps = {
	appearance: 'default',
};

const Label: React.SFC<BoxProps> = (props) =>
	<Typography.Label
		{...props}
		component='div'
		fontSize={12}
		style={{ userSelect: 'none' }}>
		{props.children}
	</Typography.Label>

export default AppSession;
